import React, { useState } from "react";
import CheckWithDate from "../CheckWithDate";
import { Box, Modal } from "@mui/material";
import ViewSelfoutingPrivileges from "../forms/ViewSelfOutingPrivileges";
import ViewButtonSmall from "../Buttons/ViewButtonSmall";

export default function FormLineConsAgreeOutingPrivilege({
  id,
  signed,
  date,
  title,
  purpose,
  clientId,
  firstName,
  lastName,
}) {
  const [showViewModal, setShowViewModal] = useState(false);
  const openViewModal = () => setShowViewModal(true);
  const closeViewModal = () => setShowViewModal(false);

  const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    boxShadow: 24,
  };

  return (
    <div
      className={
        signed
          ? "formLine-mobile-version grey-form"
          : "formLine-mobile-version light-grey-form"
      }
    >
      <Modal open={showViewModal} onClose={closeViewModal}>
        <Box sx={styleModal}>
          <ViewSelfoutingPrivileges
            clientId={clientId}
            privilegeId={id}
            firstName={firstName}
            lastName={lastName}
            closemodal={closeViewModal}
          />
        </Box>
      </Modal>

      <div
        className="formLineBlock1-mobile"
        style={{
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",

          width: "40%",
        }}
      >
        {purpose}
      </div>

      <div
        className="formLineBlock2"
        style={{
          width: "40%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {signed ? (
          <CheckWithDate checked content={date} />
        ) : (
          <CheckWithDate checked={false} />
        )}
      </div>

      <div
        className="formLineBlock3"
        style={{
          width: "20%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {signed && <ViewButtonSmall handleOpen={openViewModal} />}
      </div>
    </div>
  );
}
